// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@charset \"UTF-8\";\n.home_container {\n  width: 100%;\n  /* 关键：把下面两行注释掉或删除 */\n  /* height: calc(100vh - 90px); */\n  /* overflow: hidden; */\n}\n.full-image {\n  width: 100%;\n  height: auto;\n  /* 关键：高度设为 auto，让图片按原始比例自然显示 */\n  display: block;\n  /* 消除 img 标签底部默认的几像素幽灵空白 */\n}", ""]);
// Exports
module.exports = exports;
